import { Form } from "react-final-form";
import { onSubmit, onValidate } from "./CrmPotentialSubmit";
import SwipeableViews from "react-swipeable-views";
import { useTheme } from "@emotion/react";
import { useEffect, useState } from "react";

import CrmPotentialFormStepOne from "../CrmPotentialsSteps/CrmPotentialFormStepOne";

const CrmPotentialForm = (props) => {
  const theme = useTheme();
  const { step, setStep, update, initialValues: _initialValues } = props;
  const [initialValues, setInitialValues] = useState(null);

  useEffect(() => {
    if (update) {
      setInitialValues({
        ..._initialValues,
        clientType: _initialValues?.clientType
          ? { value: _initialValues?.clientType }
          : null,
      });
      return;
    }

    setInitialValues({});
    // eslint-disable-next-line
  }, []);

  return (
    <Form
      initialValues={initialValues}
      onSubmit={(val) => onSubmit(val, props)}
      validate={(val) => onValidate(val, props)}
      validateOnBlur={true}
    >
      {(formProps) => {
        return (
          <>
            <form
              id={props.formName}
              onSubmit={formProps.handleSubmit}
              className="CrmPotentialForm"
            >
              <SwipeableViews
                axis={theme.direction === "rtl" ? "x-reverse" : "x"}
                index={step}
                onChangeIndex={(index) => setStep(index)}
              >
                <CrmPotentialFormStepOne {...formProps} {...props} />
              </SwipeableViews>
            </form>
          </>
        );
      }}
    </Form>
  );
};

export default CrmPotentialForm;
